export const GenresEndpoints = {
	animeGenres: '/genres/anime',
	mangaGenres: '/genres/manga'
} as const
